import { render, staticRenderFns } from "./group_booking.vue?vue&type=template&id=2993da40&scoped=true"
import script from "./group_booking.vue?vue&type=script&lang=js"
export * from "./group_booking.vue?vue&type=script&lang=js"
import style0 from "./group_booking.vue?vue&type=style&index=0&id=2993da40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993da40",
  null
  
)

export default component.exports